<template>
  <span>
    <div class="workspaceHeader">
      <v-breadcrumbs :items="breadcrumbItems" divider=">">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            @click="$router.push('/' + item.href)"
            :disabled="item.disabled"
            style="font-size: 20px; color: #9c27b0; cursor: pointer;"
            >{{ item.text }}</v-breadcrumbs-item
          >
        </template>
      </v-breadcrumbs>
    </div>
    <BotPageTitle />
    <h3
      :style="{ fontSize: $vuetify.breakpoint.xsOnly ? '20px' : '' }"
      style="margin-top: 0; margin-bottom: 20px; padding: 0 15px;"
    >
      {{$t('snapshots.wizardVersions')}}
    </h3>
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>list_alt</md-icon>
            </div>
            <v-row
              no-gutters
              style="
                padding: 0;
                align-items: center !important;
                justify-content: space-between !important;
              "
            >
              <v-col cols="6">
                <h4 class="title">{{$t('snapshots.versionList')}}</h4>
              </v-col>
              <v-col cols="auto">
                <md-menu
                  @md-opened="menuImport = true"
                  @md-closed="menuImport = false"
                  md-size="huge"
                  md-direction="bottom-end"
                >
                  <md-button md-menu-trigger class="md-simple md-github">
                    <v-icon small>mdi-import</v-icon>
                    {{ $t('intentsList.import') }}
                  </md-button>
                  <md-menu-content>
                    <md-menu-item v-ripple @click="selectImport('default')"
                      >{{$t('snapshots.selectWorkspaceToImport')}}</md-menu-item
                    >
                    <md-menu-item v-ripple @click="selectImport('json')"
                      >{{$t('snapshots.importingJsonFile')}}</md-menu-item
                    >
                  </md-menu-content>
                </md-menu>
              </v-col>
            </v-row>
          </md-card-header>
          <md-card-content>
            <md-table
              :value="tableData && tableData.data"
              class="paginated-table table-striped table-hover"
            >
              <md-table-toolbar>
                <md-field>
                  <label for="pages">{{ $t('assistantsList.perPage') }}</label>
                  <md-select v-model="pagination.perPage" name="pages">
                    <md-option
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                      >{{ item }}</md-option
                    >
                  </md-select>
                </md-field>

                <md-field>
                  <md-input
                    type="search"
                    class="mb-3"
                    clearable
                    style="width: 200px;"
                    :placeholder="$t('assistantsList.search') + '...'"
                    v-model="searchQuery"
                  ></md-input>
                </md-field>
              </md-table-toolbar>

              <md-table-row
                slot="md-table-row"
                slot-scope="{ item }"
                :class="{
                  published: item._source.status === 'published',
                  checkedout: item._source.status === 'checkedout',
                  waiting: item._source.status === 'waiting',
                  approved: item._source.status === 'approved',
                  reproved: item._source.status === 'reproved',
                }"
              >
                <md-table-cell md-label="id">{{ item._id }}</md-table-cell>
                <md-table-cell :md-label="$t('commonWords.description')">
                  <span>
                    <v-icon v-if="item._source.errorToPublish" dark color="#ff9800">warning</v-icon>
                    <md-tooltip md-direction="bottom">{{ item._source.errorToPublish }}</md-tooltip>
                  </span>
                  {{ item._source.description }}
                </md-table-cell>
                <md-table-cell :md-label="$t('commonWords.createdBy')">
                  {{
                    createdByUser(item)
                      ? $t('commonWords.me')
                      : item._source.createdBy && item._source.createdBy.name
                  }}
                </md-table-cell>
                <md-table-cell :md-label="$t('snapshots.createdAt')">
                  {{
                    calculateCreatedData(item._source.createdAt).value
                  }}
                  &nbsp;
                  {{
                    calculateCreatedData(item._source.createdAt).type
                  }}
                </md-table-cell>
                <md-table-cell :md-label="$t('selectSnapshot.updatedTo')">
                  {{
                    calculateCreatedData(item._source.updatedAt).value
                  }}
                  &nbsp;
                  {{
                    calculateCreatedData(item._source.updatedAt).type
                  }}
                </md-table-cell>
                <md-table-cell :md-label="$t('selectSnapshot.userEditor')">
                  {{
                    ownedByUser(item)
                      ? $t('commonWords.I')
                      : item._source.checkedOutBy &&
                        item._source.checkedOutBy.name
                  }}
                </md-table-cell>
                <md-table-cell md-label="Status">
                  {{ getStatusLabel(item._source.status) }}
                </md-table-cell>
                <md-table-cell :md-label="$t('snapshots.actions')">
                  <span>
                    <v-btn class="mx-2" x-small fab dark color="#20A6E5" @click="
                        dialogs.visibility = true
                        itemClicked = item">
                      <v-icon dark>visibility</v-icon>
                    </v-btn>
                    <md-tooltip md-direction="bottom">{{$t('snapshots.toView')}}</md-tooltip>
                  </span>
                  <span v-if="!isApprover && (item._source.status === 'checkedout' &&(viewingMode || !ownedByUser(item)))">
                    <v-btn class="mx-2" x-small fab dark color="#20A6E5" @click="
                        dialogs.edit = true
                        itemClicked = item">
                      <v-icon dark>create</v-icon>
                    </v-btn>
                    <md-tooltip md-direction="bottom">{{$t('snapshots.editWorkspace')}}</md-tooltip>
                  </span>
                  <span v-else-if="!isApprover && (item._source.status === 'checkedout' && ownedByUser(item) && !viewingMode)">
                    <v-btn class="mx-2" x-small fab dark color="#20A6E5" @click="$goTo('/workspace')">
                      <v-icon dark>mdi-open-in-new</v-icon>
                    </v-btn>
                    <md-tooltip md-direction="bottom">{{$t('snapshots.editWorkspace')}}</md-tooltip>
                  </span>
                  <span v-if="!isApprover">
                    <v-btn class="mx-2" x-small fab dark color="#ff9800"
                      v-if="canCheckout(item._source.status)"
                      @click="
                        dialogs.checkout = true
                        itemClicked = item">
                      <v-icon dark>mdi-arrow-bottom-right</v-icon>
                    </v-btn>
                    <md-tooltip md-direction="bottom">Checkout</md-tooltip>
                  </span>
                  <v-btn class="mx-2" x-small fab dark color="#4CAF50"
                    @click="
                      dialogs.publish = true
                      itemClicked = item
                    ">
                    <v-icon dark>mdi-cloud-upload</v-icon>
                    <md-tooltip md-direction="bottom">{{$t('snapshots.publish')}}</md-tooltip>
                  </v-btn>
                  <v-btn class="mx-2" x-small fab dark color="#4CAF50"
                    v-if="!isEditor && item._source.status === 'waiting'"
                    @click="changeSnapshotStatus(item, 'approved')">
                    <v-icon dark>mdi-check-bold</v-icon>
                    <md-tooltip md-direction="bottom">Aprovar</md-tooltip>
                  </v-btn>
                  <v-btn class="mx-2" x-small fab dark color="#FF5252"
                    v-if="!isEditor && item._source.status === 'waiting'"
                    @click="changeSnapshotStatus(item, 'reproved')">
                    <v-icon dark>mdi-close-thick</v-icon>
                    <md-tooltip md-direction="bottom">Reprovar</md-tooltip>
                  </v-btn>
                  <v-btn class="mx-2" x-small fab dark color="#999999"
                    v-if="isEditor && item._source.status === 'checkedout'"
                    @click="changeSnapshotStatus(item, 'waiting')">
                    <v-icon dark>mdi-account-clock</v-icon>
                    <md-tooltip md-direction="bottom">Solicitar Aprovação</md-tooltip>
                  </v-btn>
                  <v-btn class="mx-2" x-small fab dark color="#9c27b0d1"
                    @click="downloadWithAxios(`/snapshots/${item._id}/download`, `${item.nameDownload}.json`)">
                    <v-icon dark>mdi-download</v-icon>
                    <md-tooltip md-direction="bottom">{{$t('Download')}}</md-tooltip>
                  </v-btn>
                  <v-btn v-if="(isDataPrev || isSefMg ) && item._source.status === 'published'" class="mx-2" x-small fab dark color="#ff9800" @click="testSnapshot(item)">
                    <v-icon dark>mdi-note-search-outline</v-icon>
                    <md-tooltip md-direction="bottom">Testar</md-tooltip>
                  </v-btn>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div class>
              <p class="card-category">
                {{
                  $t('assistantsList.showingItems', {
                    from: from + 1,
                    to: to,
                    total: pagination.total,
                  })
                }}
              </p>
            </div>
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.page"
              :per-page="pagination.perPage"
              :total="pagination.total"
            ></pagination>
          </md-card-actions>
        </md-card>
      </div>
    </div>
    <md-dialog-confirm
      :md-active.sync="dialogs.edit"
      :md-title="$t('snapshots.areYouSureYouWantEditThisVersion')"
      :md-content="$t('snapshots.byDoingThisOnlyYouWillBeAble')"
      :md-confirm-text="$t('snapshots.yes')"
      :md-cancel-text="$t('snapshots.no')"
      @md-cancel="dialogs.edit = false"
      @md-confirm="editSnapshot(itemClicked)"
    />
    <md-dialog-confirm
      :md-active.sync="dialogs.checkout"
      :md-title="$t('snapshots.areYouSureYouWantToCheckoutThisVersion')"
      :md-content="$t('snapshots.areYouSureYouWantToCheckoutThisVersion')"
      :md-confirm-text="$t('snapshots.yes')"
      :md-cancel-text="$t('snapshots.no')"
      @md-cancel="dialogs.checkout = false"
      @md-confirm="checkout(itemClicked)"
    />
    <md-dialog-confirm
      :md-active.sync="dialogs.publish"
      :md-title="$t('snapshots.areYouSureYouWantToPublishThisVersion')"
      :md-confirm-text="$t('snapshots.yes')"
      :md-cancel-text="$t('snapshots.no')"
      @md-cancel="dialogs.publish = false"
      @md-confirm="publish(itemClicked)"
    />
    <md-dialog-confirm
      :md-active.sync="dialogs.visibility"
      :md-title="$t('snapshots.areYouSureYouWantToViewThisVersion')"
      :md-confirm-text="$t('snapshots.yes')"
      :md-cancel-text="$t('snapshots.no')"
      @md-cancel="dialogs.visibility = false"
      @md-confirm="viewSnapshot(itemClicked)"
    />
    <v-dialog
      content-class="import-dialog"
      v-model="dialogs.import"
      max-width="1200px"
      :scrollable="true"
    >
      <ImportWorkspace
        v-if="dialogs.import"
        :importType="importType"
        @close-dialog="dialogs.import = false"
        @finish-import="finishImport"
      />
      <!-- <ImportJSONWorkspace
        v-if="importType === 'json'"publish
        :importType="importType"
        @close-dialog="dialogs.import = false"
      /> -->
    </v-dialog>
    <v-dialog
      content-class="test-dialog"
      v-model="dialogs.test"
      max-width="1200px"
      :scrollable="true"
    >
      <WorkspaceTest
        v-if="dialogs.test"
        :selectedSnapshot="selectedSnapshot"
        @close-dialog="dialogs.test = false"
      />
    </v-dialog>
    <v-fade-transition>
      <v-overlay :value="publishing">
        <v-progress-circular
          style="display: inline-block; width: 100%;"
          indeterminate
          size="64"
        />
        <div
          style="display: inline-block; width: 100%;"
          class="h2 font-weight-thin"
        >
          {{$t('snapshots.publishingVersion')}}
        </div>
      </v-overlay>
    </v-fade-transition>
  </span>
</template>

<script>
import debounce from 'lodash/debounce'
import Pagination from '@/components/Pagination.vue'
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import BotPageTitle from '@/components/BotPageTitle.vue'
import ImportWorkspace from '@/components/WorskspaceImportDialogs/ImportWorkspace.vue'
import WorkspaceTest from '@/components/WorkspaceTest.vue'
import isTenantMixin from '@/components/mixins/isTenantMixin'
import Swal from 'sweetalert2'

export default {
  components: {
    Pagination,
    BotPageTitle,
    ImportWorkspace,
    WorkspaceTest
  },
  watch: {
    searchQuery: debounce(async function () {
      const result = await this.$store.dispatch('snapshots/populate', {
        page: this.pagination.page - 1,
        perPage: this.pagination.perPage,
        searchQuery: this.searchQuery
      })
      this.pagination.total = result.total
    },
    466),
    'pagination.page': async function () {
      const result = await this.$store.dispatch('snapshots/populate', {
        page: this.pagination.page - 1,
        perPage: this.pagination.perPage,
        searchQuery: this.searchQuery
      })
      this.pagination.total = result.total
    },
    'pagination.perPage': async function () {
      const result = await this.$store.dispatch('snapshots/populate', {
        page: this.pagination.page - 1,
        perPage: this.pagination.perPage,
        searchQuery: this.searchQuery
      })
      this.pagination.total = result.total
    }
  },
  mixins: [isTenantMixin],
  computed: {
    ...mapFields('selectedAssistant', ['assistantId']),
    ...mapGetters('snapshots', {
      tableData: 'snapshots',
      viewingMode: 'viewingMode',
      appliedSnapshot: 'appliedSnapshot'
    }),
    ...mapGetters('auth', ['roles', 'user']),
    to () {
      let highBound = this.from + this.pagination.perPage
      if (this.pagination.total < highBound) {
        highBound = this.pagination.total
      }
      return highBound
    },
    from () {
      return this.pagination.perPage * (this.pagination.page - 1)
    },
    isEditor () {
      return this.roles === 'Editor'
    },
    isApprover () {
      return this.roles === 'Approver'
    },
    isAdministrador () {
      return this.roles === 'Administrador' || this.user?.functions?.find(item => item === 'chatbuilder-publish')
    }
  },
  data () {
    return {
      interval: null,
      loading: false,
      menuImport: false,
      importType: '',
      loadingText: '',
      dialogs: {
        publish: false,
        checkout: false,
        visibility: false,
        edit: false,
        import: false,
        test: false
      },
      // ordenado por:
      currentSort: 'name',
      currentSortOrder: 'asc',
      // paginação:
      pagination: {
        perPage: 5,
        page: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      // conteúdo do footer da tabela (caso dê problemas visuais, melhor tirar)
      // são strings normais
      footerTable: [
        this.$t('assistantsList.assistantName'),
        this.$t('assistantsList.channels'),
        this.$t('assistantsList.configure'),
        this.$t('assistantsList.test')
      ],
      // searchQuery é o que tá lá no computed. propsToSearch é qual das labels que vão estar incluídas na pesquisa
      // baseado no nome do campo do objeto do item
      searchQuery: '',
      propsToSearch: ['name', 'channel', 'test'],
      // conteúdo
      searchedData: [],
      fuseSearch: null,
      icons: {
        createRobot: require('../../public/img/create-robot-icon.png'),
        world: require('../../public/img/table-icon-world.png'),
        worldDisabled: require('../../public/img/table-icon-world-disabled.png'),
        fb: require('../../public/img/table-icon-fb.png'),
        fbDisabled: require('../../public/img/table-icon-fb-disabled.png'),
        wpp: require('../../public/img/table-icon-wpp.png'),
        wppDisabled: require('../../public/img/table-icon-wpp-disabled.png'),
        telegram: require('../../public/img/table-icon-telegram.png'),
        robot: require('../../public/img/table-icon-robot.png'),
        gear: require('../../public/img/table-icon-gear.png'),
        test: require('../../public/img/table-icon-testar.png')
      },
      itemClicked: {},
      publishing: false,
      breadcrumbItems: [
        // {
        //   text: 'Workspaces',
        //   disabled: false,
        //   href: 'workspaces'
        // },
        {
          text: this.$t('snapshots.versions'),
          disabled: true,
          href: 'snapshots'
        }
      ],
      selectedSnapshot: undefined
    }
  },
  // beforeMount () {
  //   window.addEventListener('beforeunload', this.preventNav)
  //   this.$once('hook:beforeDestroy', () => {
  //     window.removeEventListener('beforeunload', this.preventNav)
  //   })
  // },
  // beforeRouteLeave (to, from, next) {
  //   if (this.loading) {
  //     if (!window.confirm('Leave without saving?')) {
  //       return
  //     }
  //   }
  //   next()
  // },
  methods: {
    // preventNav (event) {
    //   if (!this.loading) return
    //   event.preventDefault()
    //   event.returnValue = ''
    // },
    canPublish (item) {
      return (this.isAdministrador && (item._source.status === 'checkedout' || item._source.status === 'approved')) || (this.isEditor && item._source.status === 'approved')
    },
    forceFileDownload (response, title) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
    },
    downloadWithAxios (url, title) {
      this.$axios({
        method: 'get',
        url,
        responseType: 'arraybuffer',
        header: {}
      })
        .then((response) => {
          this.forceFileDownload(response, title)
        })
    },
    testSnapshot (snapshot) {
      this.dialogs.test = true
      this.selectedSnapshot = snapshot._id
    },
    isBeingViewed (snapshot) {
      return this.viewingMode && snapshot._id === this.appliedSnapshot?._id
    },
    ownedByUser (snapshot) {
      return (
        snapshot._source.checkedOutBy?.id === this.$store.state.auth.user.id
      )
    },
    createdByUser (snapshot) {
      return snapshot._source.createdBy?.id === this.$store.state.auth.user.id
    },
    async editSnapshot (snapshot) {
      this.loading = true
      if (this.viewingMode) {
        this.$store.commit('snapshots/setAppliedSnapshot', snapshot)
        this.$store.commit('snapshots/setViewingMode', false)
      } else {
        await this.$store.dispatch('snapshots/steal', snapshot)
      }
      this.loading = false
      this.$router.push('/workspace')
    },
    async checkout (snapshot) {
      this.loading = true
      // this.loadingText = 'Fazendo checkout'
      try {
        await this.$store.dispatch('snapshots/checkout', snapshot)
        this.loading = false
        this.$router.push('/workspace')
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: this.$t(`snapshots.${error.message}`)
        })
      }
    },
    async publish (snapshot) {
      try {
        this.loading = true
        this.publishing = true
        const workspaceId = this.$store.getters['selectedAssistant/workspaceActiveId']
        await this.$store.dispatch('snapshots/publish', snapshot)
        await this.startPulling(snapshot._id, workspaceId)
        const result = await this.$store.dispatch('snapshots/populate', {
          page: this.pagination.page - 1,
          perPage: this.pagination.perPage,
          searchQuery: this.searchQuery
        })
        this.pagination.total = result.total
      } catch (error) {
        this.publishing = false
        this.loading = false
        if (error?.response?.status === 500) {
          const data = error?.response?.data
          Swal.fire({
            icon: 'error',
            title: this.$t('snapshots.errorPublishingWorkspace'),
            html: data?.error
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: this.$t(`snapshots.${error?.response?.data?.error}`)
          })
        }
      }
    },
    async startPulling (snapshotId, workspaceId) {
      try {
        this.interval = setInterval(async () => {
          await this.getModelStatusByTaskId(snapshotId, workspaceId).then(response => {
            const clearStatusLabels = ['complete', 'failed', 'published']
            if (clearStatusLabels.includes(response?.data?.status)) {
              this.getSnapshots()
              clearInterval(this.interval)
            }
          })
        }, 10000)
      } catch (e) {
        Swal.fire({
          icon: 'error',
          title: this.$t('snapshots.thereWasAnErrorInYourRequest')
        })
      }
      this.loading = false
      this.publishing = false
    },
    async getModelStatusByTaskId (snapshotId, workspaceId) {
      try {
        return this.$axios.get(`/snapshots/${snapshotId}/workspace/${workspaceId}/status`)
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: this.$t('snapshots.thereWasAnErrorInYourRequest')
        })
      }
    },
    deleteRow (item) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.id === item.id
      )
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1)
      }
    },
    viewSnapshot (item) {
      this.$store.commit('snapshots/view', item)
      this.$router.push('/workspace')
    },
    selectImport (type) {
      this.importType = type
      this.dialogs.import = true
    },
    async getSnapshots () {
      this.loading = true
      // this.loadingText = 'Buscando Snapshots...'
      const result = await this.$store.dispatch('snapshots/populate', {
        page: this.pagination.page - 1,
        perPage: this.pagination.perPage,
        searchQuery: this.searchQuery
      })
      // if (!result) this.$router.push('/workspaces')
      this.pagination.total = result.total
      this.loading = false
    },
    async finishImport (data, callback) {
      const workspace =
        data.workspace ||
        this.$store.getters['selectedAssistant/workspaceActiveId']

      const snapshotData =
        this.importType === 'default'
          ? await this.getSnapshotData(data.snapshot._id)
          : JSON.parse(data.json)

      try {
        const checkedoutSnap = this.$store.getters['snapshots/checkedOut']
        if (data.edit.importType === 'checkedout' && checkedoutSnap) {
          await this.$axios.delete(`/snapshots/${checkedoutSnap._id}`)
        }
        const result = await this.$axios.post('/snapshots', {
          workspace,
          data: snapshotData,
          description: data.edit.description,
          status: data.edit.importType
        })
        if (data.edit.importType === 'checkedout') {
          this.$store.commit('snapshots/setViewingMode', false)
          this.$store.commit('snapshots/setAppliedSnapshot', result?.data)
        }
        callback(null, result)
      } catch (e) {
        const errorMessageMap = {
          500: this.$t('snapshots.internalErrorContactYourAdministrator'),
          403: this.$t('snapshots.youAreNotAllowedToPerformThisOperation'),
          404: this.$t('snapshots.notFound'),
          401: this.$t('snapshots.youAreNotAuthenticatedPleaseLogin'),
          422: this.$t('snapshots.thereWasAnErrorInYourRequest')
        }
        if (e.isAxiosError) {
          callback(new Error(errorMessageMap[e.response.status]))
        } else {
          callback(new Error(errorMessageMap[500]))
        }
      }
      this.getSnapshots()
    },
    async getSnapshotData (snapshotId) {
      const snapReq = await this.$axios.get(`/snapshots/${snapshotId}`)
      return snapReq?.data?._source?.data
    },
    calculateCreatedData (date) {
      const dCreated = new Date(date)
      const dNow = Date.now()
      const diffTime = Math.abs(dNow - dCreated) / 1000
      if (diffTime < 60) {
        return {
          value: Math.floor(diffTime),
          type: this.evaluateType(Math.floor(diffTime), 'seconds')
        }
      } else if (diffTime < 60 * 60) {
        return {
          value: Math.floor(diffTime / 60),
          type: this.evaluateType(Math.floor(diffTime / 60), 'minutes')
        }
      } else if (diffTime < 60 * 60 * 24) {
        return {
          value: Math.floor(diffTime / (60 * 60)),
          type: this.evaluateType(Math.floor(diffTime / (60 * 60)), 'hours')
        }
      } else {
        return {
          value: Math.floor(diffTime / (60 * 60 * 24)),
          type: this.evaluateType(Math.floor(diffTime / (60 * 60 * 24)), 'days')
        }
      }
    },
    evaluateType (value, type) {
      if (type === 'seconds') {
        return value === 1 ? 'segundo' : 'segundos'
      } else if (type === 'minutes') {
        return value === 1 ? 'minuto' : 'minutos'
      } else if (type === 'hours') {
        return value === 1 ? 'hora' : 'horas'
      } else {
        return value === 1 ? 'dia' : 'dias'
      }
    },
    async changeSnapshotStatus (item, status) {
      try {
        const id = item._id
        await this.$axios.patch(`/snapshots/${id}/status`, { status })
        this.getSnapshots()
      } catch (err) {
      }
    },
    canCheckout (status) {
      return status === 'published' || status === 'archived' || status === 'archived' || status === 'reproved' || status === 'approved'
    },
    getStatusLabel (status) {
      switch (status) {
        case 'waiting':
          return this.$t('snapshots.waitingForApproval')
        case 'published':
          return this.$t('snapshots.published')
        case 'archived':
          return this.$t('snapshots.filed')
        case 'reproved':
          return this.$t('snapshots.reproved')
        case 'approved':
          return this.$t('snapshots.approved')
        case 'processing':
          return this.$t('snapshots.processing')
        default:
          return status
      }
    }
  },
  async created () {
    this.$store.commit('snapshots/setImportSimplifiedEditing', false)
    if (typeof this.assistantId === typeof null) {
      Swal.fire({
        text: this.$t('snapshots.pleaseSelectCognitiveAssistant'),
        icon: 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK'
      })
      this.$router.push('/lista-assistentes')
    }
    this.getSnapshots().then(async () => {
      const lastSnapshotId = this.$store.getters['snapshots/lastSnapshotId']
      const workspaceId = this.$store.getters['selectedAssistant/workspaceActiveId']
      const response = await this.getModelStatusByTaskId(lastSnapshotId, workspaceId)
      if (response.data.status === 'processing') {
        this.loading = true
        this.publishing = true
        this.interval = this.startPulling(lastSnapshotId, workspaceId)
      }
    })
  },
  beforeDestroy () {
    this.loading = false
    this.publishing = false
    clearInterval(this.interval)
  }
}
</script>

<style lang="scss" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.published {
  background-color: #69d36d !important;
}

.checkedout {
  background-color: #ffcc7f !important;
}

.waiting {
  background-color: #f5f5f5 !important;
}

.approved {
  background-color: #f5f5f5 !important;
}

.reproved {
  background-color: #f5f5f5 !important;
}

.v-btn--fab.v-size--x-small {
  height: 29px !important;
  width: 29px !important;
  margin: 0 2px;
}
.v-btn--fab.v-btn--contained {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.workspaceHeader {
  position: relative;
  top: 0;
}
.rightJustify {
  position: absolute;
  right: 4px;
}
.import-dialog {
  overflow-y: visible !important;
}

::v-deep .md-table-head:last-child {
  width: 200px;
}
</style>
